import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import Navbar from "../common/Navbar"
import Sidebar from "../common/Sidebar"
import { DailySchedule } from "../common/DailySchedule"
import { BreadCrumbCustom } from "../common/BreadCrumbCustom"

export const drawerWidth = 60

const AppLayout = ({ children }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Navbar />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: {
            xs: 1,
            sm: 3,
          },
          minHeight: "100vh",
          mr: { xs: 0, sm: "250px" },
          backgroundColor: "rgba(0,0,0,0.025)",
          pt: 5,
          pb: {
            xs: "2.3rem !important",
            sm: 3,
          },
        }}
      >
        <Toolbar
          sx={{
            minHeight: "40px !important",
          }}
        />
        <BreadCrumbCustom />

        {children}
        <DailySchedule />
      </Box>
    </Box>
  )
}

export default AppLayout
